function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useBuildStyleWithTheme } from "../ThemeProvider/useBuildStyleWithTheme";
var SIDE_WIDTH = 480;
var animationMultiplier = 1;
export var CONTENT_DURATION = 200 * animationMultiplier;
function buildStyle(param, param1) {
    var backgroundColor = param.backgroundColor, borderColor = param.borderColor, size = param.size, boxShadow = param.depth.boxShadow, start = param1.start, end = param1.end;
    return {
        outerContainer: {
            base: {
                border: 'none',
                outline: 'none',
                boxSizing: 'border-box',
                maxHeight: '100vh',
                maxWidth: '100vw',
                backgroundColor: backgroundColor.base,
                overflow: 'hidden'
            },
            inline: {
                base: {
                    height: '100%',
                    width: SIDE_WIDTH,
                    flexShrink: 0,
                    flexGrow: 0
                },
                right: {}
            },
            elevated: {
                base: {
                    position: 'fixed',
                    top: 0,
                    bottom: 0,
                    width: SIDE_WIDTH,
                    boxShadow: "".concat(boxShadow['4'].xOffset, " ").concat(boxShadow['4'].yOffset, " ").concat(boxShadow['4'].blurRadius, " ").concat(boxShadow['4'].spreadRadius, " ").concat(boxShadow['4'].color)
                },
                right: {
                    right: 0
                },
                left: {
                    left: 0
                }
            }
        },
        contentContainer: {
            boxSizing: 'border-box',
            height: '100%',
            width: '100%',
            overflow: 'hidden'
        },
        collapseCommon: {
            base: {
                height: '100%',
                borderWidth: 0,
                borderStyle: 'solid',
                borderColor: "".concat(borderColor.soft)
            },
            startFormat: _defineProperty({}, end.borderWidth, "".concat(size.border.base, "px")),
            endFormat: _defineProperty({}, start.borderWidth, "".concat(size.border.base, "px"))
        }
    };
}
function useStyle(param) {
    var isElevated = param.elevated, format = param.format, isRtl = param.isRtl, zIndex = param.zIndex;
    var ref, ref1, ref2, ref3, ref4;
    var ref5;
    var ref6 = (ref5 = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    })) !== null && ref5 !== void 0 ? ref5 : {}, outerContainer = ref6.outerContainer, contentContainer = ref6.contentContainer, collapseCommon = ref6.collapseCommon;
    return {
        outerContainerStyle: _objectSpread({}, outerContainer === null || outerContainer === void 0 ? void 0 : outerContainer.base, !isElevated ? _objectSpread({}, outerContainer === null || outerContainer === void 0 ? void 0 : (ref = outerContainer.inline) === null || ref === void 0 ? void 0 : ref.base, format === 'end' && !isRtl || format === 'start' && isRtl ? outerContainer === null || outerContainer === void 0 ? void 0 : (ref1 = outerContainer.inline) === null || ref1 === void 0 ? void 0 : ref1.right : {}) : _objectSpread({}, outerContainer === null || outerContainer === void 0 ? void 0 : (ref2 = outerContainer.elevated) === null || ref2 === void 0 ? void 0 : ref2.base, {
            zIndex: zIndex
        }, format === 'end' && !isRtl || format === 'start' && isRtl ? outerContainer === null || outerContainer === void 0 ? void 0 : (ref3 = outerContainer.elevated) === null || ref3 === void 0 ? void 0 : ref3.right : outerContainer === null || outerContainer === void 0 ? void 0 : (ref4 = outerContainer.elevated) === null || ref4 === void 0 ? void 0 : ref4.left)),
        contentContainerStyle: contentContainer,
        collapseCommonStyle: _objectSpread({}, collapseCommon === null || collapseCommon === void 0 ? void 0 : collapseCommon.base, !isElevated && (format === 'start' ? collapseCommon === null || collapseCommon === void 0 ? void 0 : collapseCommon.startFormat : collapseCommon === null || collapseCommon === void 0 ? void 0 : collapseCommon.endFormat))
    };
}
export default useStyle;
